import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useIntl } from 'react-intl';
import { PinInput } from '@mantine/core';
import InputModal from '../InputModal';
import styles from './TwoFactorRequiredModal.module.scss';
var OTP_LENGTH = 6;
export default function TwoFactorRequiredModal(param) {
    var isOpen = param.isOpen, heading = param.heading, description = param.description, onClose = param.onClose, onComplete = param.onComplete;
    var intl = useIntl();
    return /*#__PURE__*/ _jsx(InputModal, {
        title: heading,
        description: description,
        isOpen: isOpen,
        onClose: onClose,
        onSubmit: onComplete,
        submitOnValid: true,
        validPredicate: function(value) {
            return value.length === OTP_LENGTH;
        },
        submitText: intl.formatMessage({
            id: "q5Xl0M",
            defaultMessage: [
                {
                    type: 0,
                    value: "Verify"
                }
            ]
        }),
        renderInput: function(param) {
            var value = param.value, setValue = param.setValue;
            return /*#__PURE__*/ _jsx(PinInput, {
                className: styles.root,
                value: value,
                onChange: setValue,
                variant: "outline",
                length: OTP_LENGTH,
                oneTimeCode: true
            });
        }
    });
}
